// extracted by mini-css-extract-plugin
export default {"accountHeader":"Ck-z","newDesignAccountHeader":"Dk-z","primeBadge":"Ek-z","logout":"Fk-z"};